import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  OnDestroy,
  Input
} from '@angular/core';
import { Store, select } from '@ngrx/store';
import { ROUTE_ANIMATIONS_ELEMENTS } from '../../../../../core/core.module';
import { Subscription, combineLatest } from 'rxjs';
import {
  selectAllPersonas,
  selectAuthPersona
} from '../../../../persona/entity-personas/entity-personas.selectors';
import { State } from '../../../../vista-usuario/vista-usuario.state';
import { selectAllPersonasFisica } from '../../../entity-personas-fisica/entity-personas-fisica.selectors';
import { selectAllPersonasJuridica } from '../../../entity-personas-juridica/entity-personas-juridica.selectors';
import { map, switchMap, tap } from 'rxjs/operators';
import {
  EntidadesProductiva,
  EntidadesProductivaNombrePFoJ
} from '../../../entity-entidad-productiva/entity-entidades-productiva.model';
import { PersonasJuridica } from '../../../entity-personas-juridica/entity-personas-juridica.model';
import { Integrante } from '../../../../roles/integrante/integrante.model';
import { Persona } from '../../../../persona/entity-personas/entity-personas.model';
import { Laboratorio } from '../../../../actividades/entity-laboratorios/laboratorios.model';
import { SitioProcesamiento } from '../../../../actividades/entity-sitios-procesamiento/sitios-procesamiento.model';
import { selectAllLaboratoriosFromCurrentEmpresa } from '../../../../actividades/entity-laboratorios/laboratorios.selectors';
import { selectIntegrantesCurrentEmpresa } from '../../../../roles/entity-integrante/entity-integrante.selectors';
import { selectEntidadesProductivaFromCurrentEmpresa } from '../../../entity-entidad-productiva/entity-entidades-productiva.selectors';
import {
  CorreoElectronico,
  CurrentEmpresa,
  Departamento,
  Localidad,
  Pais,
  TipoRol,
  TiposDocumento
} from '@rpe/registro-personas-empresas-lib';
import { selectAllPaises } from '../../../../ubicaciones/entity-paises/entity-paises.selectors';
import { selectAllDepartamentos } from '../../../../ubicaciones/entity-departamentos/entity-departamentos.selectors';
import { selectAllLocalidades } from '../../../../ubicaciones/entity-localidades/entity-localidades.selectors';
import { selectAllDivisoresMuestra } from '../../../../actividades/entity-divisores-muestra/divisores-muestra.selectors';
import { selectAllTiposAnalisisLaboratorio } from '../../../../actividades/entity-tipos-analisis-laboratorio/tipos-analisis-laboratorio.selectors';
import { selectAllTiposEquipamientoLaboratorio } from '../../../../actividades/entity-tipos-equipamiento-laboratorio/tipos-equipamiento-laboratorio.selectors';
import {
  DivisorMuestra,
  TipoDivisorMuestra
} from '../../../../actividades/entity-divisores-muestra/divisores-muestra.model';
import { TipoAnalisisLaboratorio } from '../../../../actividades/entity-tipos-analisis-laboratorio/tipos-analisis-laboratorio.model';
import { TipoEquipamientoLaboratorio } from '../../../../actividades/entity-tipos-equipamiento-laboratorio/tipos-equipamiento-laboratorio.model';
import { selectAllEspecies } from '../../../../actividades/entity-especies/especies.selectors';
import { Especie } from '../../../../actividades/entity-especies/especies.model';
import { selectAllTiposRol } from '../../../../roles/entity-tipos-rol/entity-tipos-rol.selectors';
import { selectAllSitiosProcesamientoFromCurrentEmpresa } from '../../../../actividades/entity-sitios-procesamiento/sitios-procesamiento.selectors';
import { selectAllTiposDocumento } from '../../../../persona/entity-tipos-documento/entity-tipos-documento.selectors';
import { Deposito } from '../../../../actividades/entity-depositos/depositos.model';
import { selectAllDepositosFromCurrentEmpresa } from '../../../../actividades/entity-depositos/depositos.selectors';
import { ViveroGrupoEspecie } from '../../../../actividades/entity-viveros-grupo-especie/entity-viveros-grupo-especie.model';
import { selectViverosGrupoEspecieCurrentEmpresa } from '../../../../actividades/entity-viveros-grupo-especie/entity-viveros-grupo-especie.selectors';
import { telefonosToString } from '../../../../contactos/telefonos/telefonos.utils';
import { GrupoEspecie } from '../../../../actividades/entity-grupos-especie/grupos-especie.model';
import { selectAllGruposEspecie } from '../../../../actividades/entity-grupos-especie/grupos-especie.selectors';
import { selectAllTiposDivisorMuestra } from '../../../../actividades/entity-tipos-divisor-muestra/tipos-divisor-muestra.selectors';
import { MaquinaMovil } from '../../../../actividades/entity-maquinas-moviles/entity-maquinas-moviles.model';
import { selectAllMaquinaMovilCurrentEmpresa } from '../../../../actividades/entity-maquinas-moviles/entity-maquina-movil.selectors';

import { selectAllEstadosRol } from '../../../../roles/entity-estado-rol/entity-estados-rol.selectors';
import { EstadosRol } from "../../../../roles/entity-estado-rol/entity'estados-rol.models";

import { EstadosLaboratorio } from '../../../../actividades/entity-estados-laboratorio/estados-laboratorio.model';
import { selectAllEstadoLaboratorio } from '../../../../actividades/entity-estados-laboratorio/estados-laboratorio.selectors';
import { entityCurrentEmpresaLoadRequest } from '../../../entity-mis-empresas/entity-current-empresa.actions';
import { Router } from '@angular/router';
import { PersonasFisica } from '../../../entity-personas-fisica/entity-personas-fisica.model';
import { selectRolesPropiosByCurrentEntidadProductiva } from '../../../../roles/entity-roles/entity-roles.selectors';
import { Rol } from '../../../../roles/entity-roles/roles.model';
import { selectAllNaturalezaJuridica } from '../../../entity-naturalezas-juridica/entity-naturalezas-juridica.selectors';
import { NaturalezaJuridica } from '../../../entity-naturalezas-juridica/naturalezas-juridica.model';
import { EntityAcreditacionEmpresa } from '../../../acreditacion-empresa/entity-acreditacion-empresa.model';
import { EntityEspeciesCertificables } from '../../../../actividades/entity-especies-certificables/entity-especies-certificables.model';
import { EntityEtapasEmpresa } from '../../../entity-etapas-empresa/entity-etapas-empresa.model';
import { AcreditacionEmpresaInput } from '../acreditacion-empresa/acreditacion-empresa.interfaces';
import { selectAllEntityEtapasEmpresa } from '../../../entity-etapas-empresa/entity-etapas-empresa.selectors';
import { selectAllEntityEspeciesCertificables } from '../../../../actividades/entity-especies-certificables/entity-especies-certificables.selectors';
import { selectAcreditacionEmpresaByCurrentEmpresa } from '../../../acreditacion-empresa/entity-acreditacion-empresa.selectors';
import { downloadEmpresaDetail } from '../../../datos-empresa-pdf/download-empresa-file';
import { EmpresaFilePayload } from '../../../datos-empresa-pdf/create-empresa-file.interfaces';
import * as moment from 'moment';
import { DireccionGeografica } from '../../../../ubicaciones/direcciones-geograficas/direcciones-geografica.model';
import { getMovimientoTramiteByCurrentEmpresa } from '../../../../tramites/movimiento-tramite/movimiento-tramite.selectors';
import { MovimientoTramite } from '../../../../tramites/movimiento-tramite/movimiento-tramite.models';

export interface DetailCardComponentData {
  value: string;
  label: string;
  isLink?: boolean;
  map?: {
    input: DireccionGeografica;
    onChange?: (direccion: DireccionGeografica) => void;
  };
  onRender?: (item?: string) => string
  children?: DetailCardComponentData[];
  valueColor?: 'red';
}

@Component({
  selector: 'rpe-datos-mi-empresa-container',
  templateUrl: './datos-mi-empresa-container.component.html',
  styleUrls: ['./datos-mi-empresa-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatosMiEmpresaContainerComponent implements OnInit, OnDestroy {
  @Input() matCard: boolean;
  @Input() modificarButtons: boolean;

  modificarRoute = `/empresas/registro-empresa?modificar=true`;

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  subscriptions: Subscription[] = [];

  laboratorios: Laboratorio[] = [];
  sitiosProcesamiento: SitioProcesamiento[] = [];
  maquinasMoviles: MaquinaMovil[] = [];
  depositos: Deposito[] = [];
  viveros: ViveroGrupoEspecie[] = [];
  integrantes: Integrante[] = [];

  entidadProductiva: EntidadesProductiva = null;

  createdPersonaJuridica: PersonasJuridica = null;
  createdPersonaFisica: Persona = null;

  canEdit: boolean = false;

  countries: Pais[] = [];
  departamentos: Departamento[] = [];
  localidades: Localidad[] = [];
  tipoDivisorMuestra: DivisorMuestra[] = [];
  tipoAnalisis: TipoAnalisisLaboratorio[] = [];
  tipoEquipamientos: TipoEquipamientoLaboratorio[] = [];
  especies: Especie[] = [];
  roles: TipoRol[] = [];
  documentos: TiposDocumento[] = [];
  grupoEspecie: GrupoEspecie[];
  divisorMuestra: TipoDivisorMuestra[];
  movimientoTramiteCurrentEmpresa: MovimientoTramite[] = [];
  estadosRol: EstadosRol[] = [];
  estadosLaboratorio: EstadosLaboratorio[] = [];
  personas: Persona[] = [];
  personasFisica: PersonasFisica[] = [];
  personasJuridica: PersonasJuridica[] = [];
  naturalezaJuridica: NaturalezaJuridica[] = [];
  acreditacionEmpresa: EntityAcreditacionEmpresa[] = [];
  especiesCertificables: EntityEspeciesCertificables[] = [];
  etapasEmpresa: EntityEtapasEmpresa[] = [];
  authPersona: Persona;

  get acreditacionEmpresaInput(): AcreditacionEmpresaInput {
    return {
      acreditacionEmpresa: this.acreditacionEmpresa,
      especiesCertificables: this.especiesCertificables,
      etapasEmpresa: this.etapasEmpresa
    };
  }

  get personaJuridicaPayload(): DetailCardComponentData[] {
    const {
      denominacion_social,
      nombre_fantasia,
      rut,
      bps,
      certificado_notarial,
      naturaleza_juridica_id
    } = this.createdPersonaJuridica;

    let response = [
      { label: 'Denominación social', value: denominacion_social },
      { label: 'Nombre de fantasía', value: nombre_fantasia },
      {
        label: 'Naturaleza Juridica',
        value: this.getNaturalezaJuridica(naturaleza_juridica_id) as string
      },
      { label: 'RUT', value: String(rut) },
      { label: 'BPS', value: String(bps) },
      {
        label: 'Certificado notarial',
        value: String(certificado_notarial),
        isLink: true
      }
    ];

    if (this.onHideCertificadoNotarial(naturaleza_juridica_id)) {
      response = response.filter(
        (item) => item.label !== 'Certificado notarial'
      );
    }

    return response;
  }

  get personaFisicaPayload(): DetailCardComponentData[] {
    const detailCardComponentData = [
      {
        label: 'Nombre',
        value: `${this.createdPersonaFisica.nombre_completo}`
      },
      {
        label: 'Cédula',
        value: this.createdPersonaFisica.documentos_persona[0].numero
      },
      {
        label: 'Teléfonos',
        value: telefonosToString(
          this.createdPersonaFisica.telefonos,
          this.countries
        )
      },
      {
        label: 'Correos electrónicos',
        value:
          this.createdPersonaFisica.correo_electronico.direccion || 'No tiene'
      },
      {
        label: 'Domicilio Oficina Central',
        value: '',
        children: [
          {
            label: 'Dirección',
            value: this.createdPersonaFisica.direccion_geografica.direccion
          },
          {
            label: 'País',
            value: this.createdPersonaFisica.direccion_geografica.pais_codigo
              ? this.parsePais(
                this.createdPersonaFisica.direccion_geografica.pais_codigo
              )
              : 'No tiene'
          },
          {
            label: 'Departamento',
            value: this.createdPersonaFisica.direccion_geografica
              .departamento_codigo
              ? this.parseDepartamentos(
                this.createdPersonaFisica.direccion_geografica
                  .departamento_codigo
              )
              : 'No tiene'
          },
          {
            label: 'Localidad',
            value: this.createdPersonaFisica.direccion_geografica.localidad_id
              ? this.parseLocalidades(
                this.createdPersonaFisica.direccion_geografica.localidad_id
              )
              : 'No tiene'
          },
          {
            label: '',
            value: '',
            map: {
              input: this.createdPersonaFisica.direccion_geografica
            }
          }
        ]
      }
    ] as unknown as DetailCardComponentData[];

    return detailCardComponentData;
  }

  get entidadProductivaPayload(): DetailCardComponentData[] {
    if (!this.entidadProductiva) {
      return []; // o maneja el caso de indefinición de manera adecuada
    }

    const {
      estado,
      fecha_ultimo_estado,
      rgs,
      comercializacion,
      telefonos,
      correos_electronico,
      direccion_geografica_constituida,
      direccion_geografica_fiscal,
      direccion_geografica_correspondencia
    } = this.entidadProductiva;

    return [
      {
        label: 'Estado',
        value: String(this.parseStatusEntidadProductiva(+estado))
      },
      {
        label: 'Fecha de estado',
        value: fecha_ultimo_estado ? String(fecha_ultimo_estado) : 'No tiene'
      },
      { label: 'N° de RGS', value: rgs ? String(rgs) : 'Pendiente' },
      { label: 'Comercialización', value: comercializacion ? 'Sí' : 'No' },
      {
        label: 'Teléfonos',
        value: telefonosToString(telefonos, this.countries)
      },
      {
        label: 'Correos electrónicos',
        value: '',
        children: [
          {
            label: 'Contacto técnico',
            value: this.getCorreoTecnico(correos_electronico)
          },
          {
            label: 'Contacto administrativo',
            value: this.getCorreoAdministrativo(correos_electronico)
          },
          {
            label: 'Contacto finanzas',
            value: this.getCorreoFacturacion(correos_electronico)
          }
        ]
      },
      {
        label: 'Domicilio constituido',
        value: '',
        children: [
          {
            label: 'Dirección',
            value: direccion_geografica_constituida.direccion
          },
          {
            label: 'País',
            value: direccion_geografica_constituida.pais_codigo
              ? this.parsePais(direccion_geografica_constituida.pais_codigo)
              : 'No tiene'
          },
          {
            label: 'Departamento',
            value: direccion_geografica_constituida.departamento_codigo
              ? this.parseDepartamentos(
                direccion_geografica_constituida.departamento_codigo
              )
              : 'No tiene'
          },
          {
            label: 'Localidad',
            value: direccion_geografica_constituida.localidad_id
              ? this.parseLocalidades(
                direccion_geografica_constituida.localidad_id
              )
              : 'No tiene'
          },
          {
            label: '',
            value: '',
            map: {
              input: direccion_geografica_constituida
            }
          }
        ]
      },
      {
        label: 'Domicilio fiscal',
        value: '',
        children: [
          { label: 'Dirección', value: direccion_geografica_fiscal.direccion },
          {
            label: 'País',
            value: direccion_geografica_fiscal.pais_codigo
              ? this.parsePais(direccion_geografica_fiscal.pais_codigo)
              : 'No tiene'
          },
          {
            label: 'Departamento',
            value: direccion_geografica_fiscal.departamento_codigo
              ? this.parseDepartamentos(
                direccion_geografica_fiscal.departamento_codigo
              )
              : 'No tiene'
          },
          {
            label: 'Localidad',
            value: direccion_geografica_fiscal.localidad_id
              ? this.parseLocalidades(direccion_geografica_fiscal.localidad_id)
              : 'No tiene'
          },
          {
            label: '',
            value: '',
            map: {
              input: direccion_geografica_fiscal
            }
          }
        ]
      },
      {
        label: 'Domicilio correspondencia',
        value: '',
        children: [
          {
            label: 'Dirección',
            value: direccion_geografica_correspondencia.direccion
          },
          {
            label: 'País',
            value: direccion_geografica_correspondencia.pais_codigo
              ? this.parsePais(direccion_geografica_correspondencia.pais_codigo)
              : 'No tiene'
          },
          {
            label: 'Departamento',
            value: direccion_geografica_correspondencia.departamento_codigo
              ? this.parseDepartamentos(
                direccion_geografica_correspondencia.departamento_codigo
              )
              : 'No tiene'
          },
          {
            label: 'Localidad',
            value: direccion_geografica_correspondencia.localidad_id
              ? this.parseLocalidades(
                direccion_geografica_correspondencia.localidad_id
              )
              : 'No tiene'
          },
          {
            label: '',
            value: '',
            map: {
              input: direccion_geografica_correspondencia
            }
          }
        ]
      }
    ];
  }

  get laboratoriosPayload(): DetailCardComponentData[] {
    const labCardDetail = this.laboratorios.map((laboratorio) => {
      const analisisPorEspecie = this.agruparPorEspecie(laboratorio.analisis_especie)

      return {
        label: 'Nombre',
        value: laboratorio.nombre,
        children: [
          {
            label: 'Número',
            value: laboratorio.numero ? String(laboratorio.numero) : 'No tiene'
          },
          {
            label: 'País',
            value: laboratorio.direccion_geografica.pais_codigo
              ? this.parsePais(laboratorio.direccion_geografica.pais_codigo)
              : 'No tiene'
          },
          {
            label: 'Departamento',
            value: laboratorio.direccion_geografica.departamento_codigo
              ? this.parseDepartamentos(
                laboratorio.direccion_geografica.departamento_codigo
              )
              : 'No tiene'
          },
          {
            label: 'Localidad',
            value: laboratorio.direccion_geografica.localidad_id
              ? this.parseLocalidades(
                laboratorio.direccion_geografica.localidad_id
              )
              : 'No tiene'
          },
          {
            label: 'Dirección',
            value: laboratorio.direccion_geografica.direccion,
            map: {
              input: laboratorio.direccion_geografica
            }
          },
          {
            label: 'Teléfonos',
            value: telefonosToString(laboratorio.telefonos, this.countries)
          },
          {
            label: 'Correos electrónicos',
            value:
              laboratorio.correos_electronico
                .map((correo) => correo.direccion)
                .join(', ') || 'No tiene'
          },
          {
            label: 'Balanzas',
            value:
              laboratorio.balanzas
                .map(
                  (balanza) =>
                    `Capacidad: ${parseInt(
                      balanza.capacidad.toString()
                    )} (g), Precisión: ${balanza.precision} (n° decimales)`
                )
                .join('; ') || 'No tiene'
          },
          {
            label: 'Germinadoras',
            value:
              laboratorio.germinadores
                .map(
                  (germinador) =>
                    `Temperatura Mínima: ${parseInt(
                      germinador.minima_temperatura.toString()
                    )} (°C), Temperatura Máxima: ${parseInt(
                      germinador.maxima_temperatura.toString()
                    )} (°C)`
                )
                .join('; ') || 'No tiene'
          },
          {
            label: 'Divisores de Muestra',
            value:
              laboratorio.divisores_muestra
                .map((divisor) =>
                  this.buscarDivisorMuestra(divisor.tipo_divisor_muestra_id)
                )
                .join('; ') || ''
          },
          {
            label: 'Especies y análisis',
            onRender: () => {
              const analisis = analisisPorEspecie
                .map((analisis: any) => {
                  const analisisTipo = analisis.tiposAnalisis.map((tipo: any) => this.parseTipoAnalisis(+tipo).trim()).join(' - ');
                  const especie = this.parseEspecie(+analisis.especie).trim();

                  return `<div style="margin: 15px 0;"><br><b>${especie}</b> <br>${analisisTipo}</div>`;
                }) || 'No tiene';

              // Remove [ and ], all double quotes, and commas from the stringified array
              return `<div>${JSON.stringify(analisis)
                .replace(/^\[|\]$/g, '')
                .replace(/"/g, '')
                .replace(/,/g, '')
                }<br></div>`;
            },
            value: laboratorio.analisis_especie,
          },
          {
            label: 'Equipamientos',
            value:
              laboratorio.equipamientos
                .map(
                  (equipamiento) =>
                    `${this.parseTipoEquipamiento(
                      equipamiento.tipo_equipamiento_laboratorio_id
                    )}`
                )
                .join('; ') || 'No tiene'
          },
          {
            label: 'Estado',
            value: this.getNombreEstadoLaboratorioById(laboratorio.estado_id)
          },
          {
            label: 'Acreditación Nacional',
            value: laboratorio?.acreditado_nacional ? 'Sí' : 'No'
          },
          {
            label: 'Acreditación MERCOSUR',
            value: laboratorio?.acreditado_mercosur ? 'Sí' : 'No'
          }
        ]
      } as unknown as DetailCardComponentData;
    });

    return labCardDetail;
  }

  get integrantesPayload(): DetailCardComponentData[] {
    const integrantes = this.integrantes.map((integrante) => {
      return {
        label: 'Nombre completo',
        value: integrante.nombre_completo,
        children: [
          {
            label: 'Documento',
            value: `${this.parsePais(
              integrante.documento_persona.pais_codigo
            )} ${this.parseDocumentos(
              integrante.documento_persona.tipo_documento_codigo
            )} - ${integrante.documento_persona.numero}`
          },
          {
            label: 'Rol',
            value: this.parseTipoRol(integrante.rol.tipo_rol_id)
          },
          ...(integrante.rol.tipo_rol_id === 7 ? [{
            label: 'Laboratorios',
            value: this.buscarLaboratoriosById(integrante.rol.laboratorios_id).map((laboratorio) => `${laboratorio.nombre}`).join('; ') || 'No tiene'
          },] : []),
          {
            label: 'Acreditación representación',
            value:
              integrante.rol.acreditacion_representacion != null
                ? String(integrante.rol.acreditacion_representacion)
                : null,
            isLink: true
          },
          {
            label: 'Estado',
            value: this.parseEstadosRol(+integrante.rol.estado_id)
          }
        ]
      } as unknown as DetailCardComponentData;
    });
    return integrantes;
  }

  get sitiosProcesamientoPayload(): DetailCardComponentData[] {
    const detailCardComponentData = this.sitiosProcesamiento?.map(
      (sitioProcesamiento) => {
        let data = {
          label: 'Nombre Sitio Procesamiento',
          value: sitioProcesamiento.nombre,
          children: [
            {
              label: 'Dirección',
              value: sitioProcesamiento.direccion_geografica.direccion
            },
            {
              label: 'País',
              value: sitioProcesamiento.direccion_geografica.pais_codigo
                ? this.parsePais(
                  sitioProcesamiento.direccion_geografica.pais_codigo
                )
                : 'No tiene'
            },
            {
              label: 'Departamento',
              value: sitioProcesamiento.direccion_geografica.departamento_codigo
                ? this.parseDepartamentos(
                  sitioProcesamiento.direccion_geografica.departamento_codigo
                )
                : 'No tiene'
            },
            {
              label: 'Localidad',
              value: sitioProcesamiento.direccion_geografica.localidad_id
                ? this.parseLocalidades(
                  sitioProcesamiento.direccion_geografica.localidad_id
                )
                : 'No tiene'
            },
            {
              map: {
                input: sitioProcesamiento.direccion_geografica
              }
            },
            {
              label: 'Teléfonos',
              value: telefonosToString(
                sitioProcesamiento.telefonos,
                this.countries
              )
            },
            {
              label: 'Correos electrónicos',
              value:
                sitioProcesamiento.correos_electronico
                  .map((correo) => correo.direccion)
                  .join(', ') || 'No tiene'
            },
            {
              label: 'Brinda Servicios a Terceros',
              value: sitioProcesamiento.brinda_servicios_terceros ? 'Sí' : 'No'
            },
            {
              label: 'Equipamientos',
              value:
                sitioProcesamiento.equipamientos
                  .map(
                    (equipamiento) =>
                      `Nombre: ${equipamiento.tipo_equipamiento_procesamiento_nombre}, Marca: ${equipamiento.marca}, Modelo: ${equipamiento.modelo}`
                  )
                  .join(';') || 'No tiene'
            },
            {
              label: 'Cantidad de máquinas Fijas',
              value: sitioProcesamiento.equipamientos.length || 'No tiene'
            }
          ]
        } as unknown as DetailCardComponentData;

        if (!sitioProcesamiento.nombre) {
          data = {
            ...data,
            label: '',
            value: ''
          };
        }

        return data;
      }
    );

    return detailCardComponentData;
  }

  get depositosPayload(): DetailCardComponentData[] {
    const detailCardComponentData = this.depositos.map((deposito) => {
      return {
        label: 'Nombre depósito',
        value: deposito.nombre,
        children: [
          {
            label: 'Dirección',
            value: deposito.direccion_geografica.direccion
          },
          {
            label: 'País',
            value: deposito.direccion_geografica.pais_codigo
              ? this.parsePais(deposito.direccion_geografica.pais_codigo)
              : 'No tiene'
          },
          {
            label: 'Departamento',
            value: deposito.direccion_geografica.departamento_codigo
              ? this.parseDepartamentos(
                deposito.direccion_geografica.departamento_codigo
              )
              : 'No tiene'
          },
          {
            label: 'Localidad',
            value: deposito.direccion_geografica.localidad_id
              ? this.parseLocalidades(
                deposito.direccion_geografica.localidad_id
              )
              : 'No tiene'
          },
          {
            label: '',
            value: '',
            map: {
              input: deposito.direccion_geografica
            }
          },
          {
            label: 'Teléfonos',
            value: telefonosToString(deposito.telefonos, this.countries)
          },
          {
            label: 'Correos electrónicos',
            value:
              deposito.correos_electronico
                .map((correo) => correo.direccion)
                .join(', ') || 'No tiene'
          }
        ]
      } as unknown as DetailCardComponentData;
    });

    return detailCardComponentData;
  }

  get maquinasMovilesPayload(): DetailCardComponentData[] {
    const detailCardComponentData = this.maquinasMoviles?.map(
      (maquinaMovil) => {
        return {
          label: 'Número de máquina móvil',
          value: maquinaMovil.id,
          children: [
            {
              label: 'Equipamientos',
              value:
                maquinaMovil.equipamientos
                  .map((equipamientos) => {
                    let equipamientoString = `Nombre: ${equipamientos.tipo_equipamiento_procesamiento_nombre}. Marca: ${equipamientos.marca}. Modelo: ${equipamientos.modelo}`;
                    if (equipamientos.gps !== null) {
                      equipamientoString += `. GPS: ${equipamientos.gps}`;
                    }
                    if (equipamientos.n_precinto !== null) {
                      equipamientoString += `. Precinto: ${equipamientos.n_precinto}`;
                    }
                    return equipamientoString;
                  })
                  .join('; ') || 'No tiene'
            },
            {
              label: 'Teléfonos',
              value: telefonosToString(maquinaMovil.telefonos, this.countries)
            },
            {
              label: 'Correos electrónicos',
              value:
                maquinaMovil.correos_electronico
                  .map((correo) => correo.direccion)
                  .join(', ') || 'No tiene'
            },
            {
              label: 'Brinda Servicios a Terceros',
              value: maquinaMovil.brinda_servicios_terceros ? 'Sí' : 'No'
            }
          ]
        } as unknown as DetailCardComponentData;
      }
    );

    return detailCardComponentData;
  }

  get viverosPayload(): DetailCardComponentData[] {
    const detailCardComponentData = this.viveros.map((vge) => {
      const especies = this.buscarNombreEspecie(vge.grupos_especies_id).join(
        '; '
      );
      return {
        label: 'Nombre',
        value: vge.nombre,
        children: [
          {
            label: 'Especies',
            value: especies || 'No tiene'
          },
          {
            label: 'Dirección',
            value: vge.direccion_geografica.direccion
          },
          {
            label: 'País',
            value: vge.direccion_geografica.pais_codigo
              ? this.parsePais(vge.direccion_geografica.pais_codigo)
              : 'No tiene'
          },
          {
            label: 'Departamento',
            value: vge.direccion_geografica.departamento_codigo
              ? this.parseDepartamentos(
                vge.direccion_geografica.departamento_codigo
              )
              : 'No tiene'
          },
          {
            label: 'Localidad',
            value: vge.direccion_geografica.localidad_id
              ? this.parseLocalidades(vge.direccion_geografica.localidad_id)
              : 'No tiene'
          },
          {
            label: 'Dirección',
            value: vge.direccion_geografica.direccion,
            map: {
              input: vge.direccion_geografica
            }
          }
        ]
      } as unknown as DetailCardComponentData;
    });
    return detailCardComponentData;
  }

  constructor(public store: Store<State>, private router: Router) { }

  ngOnInit(): void {
    const s = combineLatest([
      this.store.pipe(select(selectAllEntityEtapasEmpresa)),
      this.store.pipe(select(selectAllEntityEspeciesCertificables)),
      this.store.pipe(select(selectAcreditacionEmpresaByCurrentEmpresa)),
      this.store.pipe(select(getMovimientoTramiteByCurrentEmpresa))
    ]).subscribe(
      ([
        etapasEmpresa,
        especiesCertificables,
        acreditacionEmpresa,
        movimientoTramiteCurrentEmpresa
      ]) => {
        this.etapasEmpresa = etapasEmpresa;
        this.especiesCertificables = especiesCertificables;
        this.acreditacionEmpresa = acreditacionEmpresa;
        this.movimientoTramiteCurrentEmpresa = movimientoTramiteCurrentEmpresa;
      }
    );

    const authPersonaSubscription = this.store
      .pipe(select(selectAuthPersona))
      .subscribe((persona) => {
        this.authPersona = persona;
      });

    const countriesSubscription = this.store
      .pipe(select(selectAllPaises))
      .subscribe((countries) => {
        this.countries = countries;
      });

    const departamentosSubscription = this.store
      .pipe(select(selectAllDepartamentos))
      .subscribe((departamentos) => {
        this.departamentos = departamentos;
      });

    const localidadesSubscription = this.store
      .pipe(select(selectAllLocalidades))
      .subscribe((localidades) => {
        this.localidades = localidades;
      });

    const divisoresTipoMuestraSubscription = this.store
      .pipe(select(selectAllDivisoresMuestra))
      .subscribe((divisoresMuestra) => {
        this.tipoDivisorMuestra = divisoresMuestra;
      });

    const analisisSubscription = this.store
      .pipe(select(selectAllTiposAnalisisLaboratorio))
      .subscribe((tipoAnalisis) => {
        this.tipoAnalisis = tipoAnalisis;
      });

    const tipoEquipamientoSubscription = this.store
      .pipe(select(selectAllTiposEquipamientoLaboratorio))
      .subscribe((tipoEquipamiento) => {
        this.tipoEquipamientos = tipoEquipamiento;
      });

    const especiesSubscription = this.store
      .pipe(select(selectAllEspecies))
      .subscribe((especies) => {
        this.especies = especies;
      });

    const rolesSubscription = this.store
      .pipe(select(selectAllTiposRol))
      .subscribe((tiposRol) => {
        this.roles = tiposRol;
      });

    const documentSubscription = this.store
      .pipe(select(selectAllTiposDocumento))
      .subscribe((tiposDocumento) => {
        this.documentos = tiposDocumento;
      });

    const currentEmpresaSubscription = this.store
      .pipe(select(selectEntidadesProductivaFromCurrentEmpresa))
      .pipe(
        map((ep) => {
          this.entidadProductiva = ep[0];
        }),
        switchMap(() => {
          return this.store.select(selectAllPersonasJuridica);
        }),
        tap((pj) => {
          if (pj.length > 0) {
            this.createdPersonaJuridica = pj.find((pj) => {
              return pj.id === this.entidadProductiva?.persona_juridica_id;
            });
          }
        }),
        switchMap(() => {
          return this.store.select(selectAllPersonasFisica).pipe(
            switchMap((pf) => {
              return this.store.select(selectAllPersonas).pipe(
                map((p) => {
                  return pf.map((personaFisica) => {
                    return {
                      ...personaFisica,
                      persona: p.find(
                        (persona) => persona.id === personaFisica.persona_id
                      )
                    };
                  });
                })
              );
            })
          );
        }),
        tap((pf) => {
          if (pf.length > 0) {
            this.createdPersonaFisica = pf.find((pf) => {
              return pf.id === this.entidadProductiva?.persona_fisica_id;
            })
              ? pf.find((pf) => {
                return pf.id === this.entidadProductiva?.persona_fisica_id;
              }).persona
              : null;
          }
        }),
        switchMap(() => {
          return this.store
            .select(selectAllLaboratoriosFromCurrentEmpresa)
            .pipe(
              tap((laboratorios) => {
                this.laboratorios = laboratorios;
              })
            );
        }),
        switchMap(() => {
          return this.store.select(selectIntegrantesCurrentEmpresa).pipe(
            tap((integrantes) => {
              this.integrantes = integrantes;
            })
          );
        }),
        switchMap(() => {
          return this.store
            .select(selectAllSitiosProcesamientoFromCurrentEmpresa)
            .pipe(
              tap((sitiosProcesamiento) => {
                this.sitiosProcesamiento = sitiosProcesamiento;
              })
            );
        })
      )
      .subscribe();

    //Depositos
    const subscriptionDeposito = this.store
      .select(selectAllDepositosFromCurrentEmpresa)
      .subscribe((ds) => {
        this.depositos = ds;
      });

    const subscriptionEstadoRol = this.store
      .select(selectAllEstadosRol)
      .subscribe((int) => {
        this.estadosRol = int;
      });

    //Maquinas Moviles
    const subscriptionMaquinasMoviles = this.store
      .select(selectAllMaquinaMovilCurrentEmpresa)
      .subscribe((mm) => {
        this.maquinasMoviles = mm;
      });

    //Viveros
    const subscriptionViveros = this.store
      .select(selectViverosGrupoEspecieCurrentEmpresa)
      .subscribe((vge) => (this.viveros = vge));

    // GrupoEspecie
    const susbcriptionGrupoEspecie = this.store
      .select(selectAllGruposEspecie)
      .subscribe((data: GrupoEspecie[]) => {
        this.grupoEspecie = data;
      });

    // DivisorMuestra
    const subscriptionDivisorMuestra = this.store
      .select(selectAllTiposDivisorMuestra)
      .subscribe((data: TipoDivisorMuestra[]) => {
        this.divisorMuestra = data;
      });

    /// EstadosLaboratorio

    const subscriptionEstadosLaboratorios = this.store
      .select(selectAllEstadoLaboratorio)
      .subscribe((data: EstadosLaboratorio[]) => {
        this.estadosLaboratorio = data;
      });

    /// personas
    const personasSubscription = this.store
      .select(selectAllPersonas)
      .subscribe((personas) => {
        this.personas = personas;
      });

    /// personaFisica

    const personasFisicaSubscription = this.store
      .select(selectAllPersonasFisica)
      .subscribe((personasFisica) => {
        this.personasFisica = personasFisica;
      });

    /// personaJuridica

    const personasJuridicaSubscription = this.store
      .select(selectAllPersonasJuridica)
      .subscribe((personaJuridica) => {
        this.personasJuridica = personaJuridica;
      });

    //const rolesByEntidadProductivaSubscription = this.store.pipe(select(selectRolesPropiosByEntidadProductivaId(this.entidadProductiva.id))).subscribe((result) => {
    const rolesByEntidadProductivaSubscription = this.store
      .pipe(select(selectRolesPropiosByCurrentEntidadProductiva))
      .subscribe((result) => {
        this.canEdit = this.almotOneEditableRol(result);
      });

    const naturalezaJuridicaSubscription = this.store
      .select(selectAllNaturalezaJuridica)
      .subscribe((naturalezaJuridica) => {
        this.naturalezaJuridica = naturalezaJuridica;
      });

    this.subscriptions.push(
      naturalezaJuridicaSubscription,
      countriesSubscription,
      departamentosSubscription,
      localidadesSubscription,
      divisoresTipoMuestraSubscription,
      analisisSubscription,
      tipoEquipamientoSubscription,
      especiesSubscription,
      rolesSubscription,
      currentEmpresaSubscription,
      documentSubscription,
      subscriptionDeposito,
      subscriptionViveros,
      susbcriptionGrupoEspecie,
      subscriptionDivisorMuestra,
      subscriptionMaquinasMoviles,
      subscriptionEstadoRol,
      subscriptionEstadosLaboratorios,
      personasSubscription,
      personasFisicaSubscription,
      personasJuridicaSubscription,
      rolesByEntidadProductivaSubscription,
      s
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

  getCorreoFacturacion(correos: CorreoElectronico[]): string {
    return this.parseEmails(
      correos.filter((correo) => correo.tipo_correo_id === 3)
    );
  }

  getCorreoAdministrativo(correos: CorreoElectronico[]): string {
    return this.parseEmails(
      correos.filter((correo) => correo.tipo_correo_id === 2)
    );
  }

  getCorreoTecnico(correos: CorreoElectronico[]): string {
    return this.parseEmails(
      correos.filter((correo) => correo.tipo_correo_id === 1)
    );
  }

  parseEmails(emails: CorreoElectronico[]): string {
    return emails.map((email) => email.direccion).join(', ');
  }

  getNaturalezaJuridica(naturalezaJuridicaId: number): string | String {
    return (
      this.naturalezaJuridica.find((nj) => nj.id === naturalezaJuridicaId)
        ?.nombre || 'No tiene'
    );
  }

  parsePais(pais_codigo: string): string {
    return this.findPaisByPaisCodigo(pais_codigo)
      ? this.findPaisByPaisCodigo(pais_codigo).nombre
      : 'No tiene';
  }

  findPaisByPaisCodigo(pais_codigo: string): Pais {
    return this.countries.find((p) => {
      return p.codigo === pais_codigo;
    });
  }

  parseDepartamentos(departamento_codigo: string): string {
    return this.departamentos.find((d) => {
      return d.codigo === departamento_codigo;
    })?.nombre;
  }

  agruparPorEspecie(data: { especie_id: number, tipo_analisis_laboratorio_id: number }[]): { especie: string, tiposAnalisis: string[] }[] {
    const resultado: Record<string, Set<string>> = {};

    data.forEach((item) => {
      const especieKey = String(item.especie_id);

      if (!resultado[especieKey]) {
        resultado[especieKey] = new Set();
      }

      resultado[especieKey].add(String(item.tipo_analisis_laboratorio_id));
    });

    return Object.entries(resultado).map(([especie, tiposSet]) => ({
      especie,
      tiposAnalisis: Array.from(tiposSet),
    }));
  }

  parseLocalidades(localidad_id: number): string {
    return (
      this.localidades.find((l) => {
        return l.id === localidad_id;
      })?.nombre || 'No tiene'
    );
  }

  parseDocumentos(documento_id: number): string {
    return this.documentos.find((d) => {
      return d.codigo === documento_id;
    })?.nombre;
  }

  parseDirecciones(direccion: DireccionGeografica): string {
    const address = '\b Direccion: \b' + ' ' + direccion.direccion;
    const country = direccion.pais_codigo
      ? '\b Pais: \b' +
      ' ' +
      this.countries.find((p) => {
        return p.codigo === direccion.pais_codigo;
      })?.nombre
      : '';

    return address + ' ' + country;
  }

  parseEspecie(especie_id: number): string {
    return (
      this.especies.find((e) => {
        return e.id === especie_id;
      })?.nombre_comun +
      ' (' +
      this.especies.find((e) => {
        return e.id === especie_id;
      })?.nombre_cientifico +
      ')'
    );
  }

  // parseTipoDivisorMuestra(tipo_divisor_muestra_id: number): number {
  //   return this.tipoDivisorMuestra.find((tdm) => { return tdm.id === tipo_divisor_muestra_id }).tipo_divisor_muestra_id
  // }

  parseTipoAnalisis(tipo_analisis_laboratorio_id: number): string {
    return this.tipoAnalisis.find((tal) => {
      return tal.id === tipo_analisis_laboratorio_id;
    })?.nombre;
  }

  parseTipoEquipamiento(tipo_equipamiento_laboratorio_id: number): string {
    return this.tipoEquipamientos.find((tel) => {
      return tel.id === tipo_equipamiento_laboratorio_id;
    })?.nombre;
  }

  parseEstadosRol(estado_id: number): string {
    return (
      this.estadosRol.find((er) => {
        return er.id === estado_id;
      })?.nombre || 'Pendiente'
    );
  }

  parseStatusEntidadProductiva(status: number): string {
    switch (status) {
      case 1:
        return 'Solicitud de alta';
      case 2:
        return 'Pendiente de evaluación';
      case 3:
        return 'Alta';
      default:
        return '';
    }
  }

  parseTipoRol(tipo_rol_id: number): string {
    return this.roles.find((r) => {
      return r.id === tipo_rol_id;
    })?.nombre;
  }

  buscarNombreEspecie(ids: number[] | null): string[] {
    if (ids == null) {
      return [];
    }

    const nombresEspecies: string[] = [];

    ids.forEach((id, index) => {
      const especie = this.grupoEspecie.find((e) => e.id === id);
      if (especie) {
        nombresEspecies.push(especie.nombre);
      } else {
        nombresEspecies.push(`Especie con ${id} no encontrada`);
      }

      if (index < ids.length - 1) {
        nombresEspecies.push(' ');
      }
    });

    return nombresEspecies;
  }

  buscarDivisorMuestra(id: number | null): string {
    if (id == null) {
      return '';
    }

    const divisorMuestra = this.divisorMuestra.find((e) => e.id === id);
    if (divisorMuestra) {
      return divisorMuestra.nombre;
    } else {
      return `Divisor de Muestra con ${id} no encontrada`;
    }
  }

  getNombreEstadoLaboratorioById(id: number) {
    const lab = this.estadosLaboratorio.find((lab) => lab.id === id);
    return lab ? lab.nombre : 'Pendiente';
  }

  //// modificar empresa ////

  modificarEmpresa() {
    this.onSelectEmpresa({
      idEntidadProductiva: this.entidadProductiva.id,
      nombrePersonaFoJ: this.nombreEmpresa(this.entidadProductiva)
    });
  }

  onSelectEmpresa(empresa: EntidadesProductivaNombrePFoJ) {
    let auxCE: CurrentEmpresa = {
      nombre: empresa.nombrePersonaFoJ,
      id: empresa.idEntidadProductiva
    };

    this.store.dispatch(
      entityCurrentEmpresaLoadRequest({
        item: auxCE
      })
    );

    this.router.navigateByUrl(this.modificarRoute);
  }

  personaById(personaId: number): Persona {
    return this.personas.find((p) => p.id === personaId);
  }

  personaFisicaByEntidadProductiva(
    entidadProductiva: EntidadesProductiva
  ): PersonasFisica {
    return this.personasFisica.find(
      (pf) => pf.id === entidadProductiva.persona_fisica_id
    );
  }

  personaJuridicaById(personaId: number): PersonasJuridica {
    return this.personasJuridica.find((pj) => pj.id === personaId);
  }

  downloadEmpresaFile(): void {
    const empresaDetail: EmpresaFilePayload = {
      userName: this.authPersona.nombre_completo,
      empresa: {
        denominacionSocial: this.createdPersonaJuridica.denominacion_social,
        nombreFantasia: this.createdPersonaJuridica.nombre_fantasia,
        rut: this.createdPersonaJuridica.rut,
        bps: String(this.createdPersonaJuridica.bps),
        estado: String(
          this.parseStatusEntidadProductiva(+this.entidadProductiva.estado)
        ),
        fechaDeEstado: moment(
          this.entidadProductiva.fecha_ultimo_estado
        ).format('DD/MM/YYYY'),
        rgs: String(this.entidadProductiva.rgs),
        telefono: telefonosToString(
          this.entidadProductiva.telefonos,
          this.countries
        ),
        correosElectronicos: {
          contactoTecnico: this.getCorreoTecnico(
            this.entidadProductiva.correos_electronico
          ),
          contactoAdministrativo: this.getCorreoAdministrativo(
            this.entidadProductiva.correos_electronico
          ),
          contactoFinanzas: this.getCorreoFacturacion(
            this.entidadProductiva.correos_electronico
          )
        },
        domicilioConstituido: {
          direccion:
            this.entidadProductiva.direccion_geografica_constituida.direccion,
          pais: this.parsePais(
            this.entidadProductiva.direccion_geografica_constituida.pais_codigo
          ),
          departamento: this.parseDepartamentos(
            this.entidadProductiva.direccion_geografica_constituida
              .departamento_codigo
          ),
          localidad: this.parseLocalidades(
            this.entidadProductiva.direccion_geografica_constituida.localidad_id
          )
        },
        domicilioFiscal: {
          direccion:
            this.entidadProductiva.direccion_geografica_fiscal.direccion,
          pais: this.parsePais(
            this.entidadProductiva.direccion_geografica_fiscal.pais_codigo
          ),
          departamento: this.parseDepartamentos(
            this.entidadProductiva.direccion_geografica_fiscal
              .departamento_codigo
          ),
          localidad: this.parseLocalidades(
            this.entidadProductiva.direccion_geografica_fiscal.localidad_id
          )
        },
        domicilioCorrespondiente: {
          direccion:
            this.entidadProductiva.direccion_geografica_correspondencia
              .direccion,
          pais: this.parsePais(
            this.entidadProductiva.direccion_geografica_correspondencia
              .pais_codigo
          ),
          departamento: this.parseDepartamentos(
            this.entidadProductiva.direccion_geografica_correspondencia
              .departamento_codigo
          ),
          localidad: this.parseLocalidades(
            this.entidadProductiva.direccion_geografica_correspondencia
              .localidad_id
          )
        }
      },
      integrantes: this.integrantes.map((integrante) => {
        return {
          nombre: integrante.nombre_completo,
          documento: `${this.parsePais(
            integrante.documento_persona.pais_codigo
          )} ${this.parseDocumentos(
            integrante.documento_persona.tipo_documento_codigo
          )} - ${integrante.documento_persona.numero}`,
          rol: this.parseTipoRol(integrante.rol.tipo_rol_id),
          estado: this.parseEstadosRol(+integrante.rol.estado_id)
        };
      }),
      depositosYDependendencias: {
        laboratorios: this.laboratorios.map((laboratorio) => {
          return {
            nombre: laboratorio.nombre,
            direccion: laboratorio.direccion_geografica.direccion,
            pais: this.parsePais(laboratorio.direccion_geografica.pais_codigo),
            departamento: this.parseDepartamentos(
              laboratorio.direccion_geografica.departamento_codigo
            ),
            localidad: this.parseLocalidades(
              laboratorio.direccion_geografica.localidad_id
            ),
            telefonos: telefonosToString(laboratorio.telefonos, this.countries),
            correosElectronicos: laboratorio.correos_electronico
              .map((correo) => correo.direccion)
              .join(', '),
            balanzas: laboratorio.balanzas
              .map(
                (balanza) =>
                  `Capacidad: ${parseInt(
                    balanza.capacidad.toString()
                  )} (g), Precisión: ${balanza.precision} (n° decimales)`
              )
              .join('; '),
            germinadoras: laboratorio.germinadores
              .map(
                (germinador) =>
                  `Temperatura Mínima: ${parseInt(
                    germinador.minima_temperatura.toString()
                  )} (°C), Temperatura Máxima: ${parseInt(
                    germinador.maxima_temperatura.toString()
                  )} (°C)`
              )
              .join('; '),
            divisoresMuestra: laboratorio.divisores_muestra
              .map((divisor) =>
                this.buscarDivisorMuestra(divisor.tipo_divisor_muestra_id)
              )
              .join('; '),
            especiesYAnalisis: laboratorio.analisis_especie
              .map(
                (analisis) =>
                  `Especie: ${this.parseEspecie(
                    analisis.especie_id
                  )}. Análisis: ${this.parseTipoAnalisis(
                    analisis.tipo_analisis_laboratorio_id
                  )}`
              )
              .join('; '),
            equipamientos: laboratorio.equipamientos
              .map((equipamiento) =>
                this.parseTipoEquipamiento(
                  equipamiento.tipo_equipamiento_laboratorio_id
                )
              )
              .join('; '),
            estado: this.getNombreEstadoLaboratorioById(laboratorio.estado_id)
          };
        }),
        sitiosProcesamiento: this.sitiosProcesamiento.map(
          (sitioProcesamiento) => {
            return {
              nombre: sitioProcesamiento.nombre,
              direccion: sitioProcesamiento.direccion_geografica.direccion,
              pais: this.parsePais(
                sitioProcesamiento.direccion_geografica.pais_codigo
              ),
              departamento: this.parseDepartamentos(
                sitioProcesamiento.direccion_geografica.departamento_codigo
              ),
              localidad: this.parseLocalidades(
                sitioProcesamiento.direccion_geografica.localidad_id
              ),
              telefonos: telefonosToString(
                sitioProcesamiento.telefonos,
                this.countries
              ),
              correosElectronicos: sitioProcesamiento.correos_electronico
                .map((correo) => correo.direccion)
                .join(', '),
              brindaServicios:
                sitioProcesamiento.brinda_servicios_terceros ? 'Sí' : 'No',
              equipamientos: sitioProcesamiento.equipamientos
                .map(
                  (equipamiento) =>
                    `Nombre: ${equipamiento.tipo_equipamiento_procesamiento_nombre}, Marca: ${equipamiento.marca}, Modelo: ${equipamiento.modelo}`
                )
                .join('; ')
            };
          }
        ),
        depositos: this.depositos.map((deposito) => {
          return {
            nombre: deposito.nombre,
            direccion: deposito.direccion_geografica.direccion,
            pais: this.parsePais(deposito.direccion_geografica.pais_codigo),
            departamento: this.parseDepartamentos(
              deposito.direccion_geografica.departamento_codigo
            ),
            localidad: this.parseLocalidades(
              deposito.direccion_geografica.localidad_id
            ),
            telefonos: telefonosToString(deposito.telefonos, this.countries),
            correosElectronicos: deposito.correos_electronico
              .map((correo) => correo.direccion)
              .join(', ')
          };
        }),
        maquinaMovil: this.maquinasMoviles.map((maquinaMovil) => {
          return {
            numero: maquinaMovil.id,
            equipamientos: maquinaMovil.equipamientos
              .map((equipamientos) => {
                let equipamientoString = `Nombre: ${equipamientos.tipo_equipamiento_procesamiento_nombre}. Marca: ${equipamientos.marca}. Modelo: ${equipamientos.modelo}`;
                if (equipamientos.gps !== null) {
                  equipamientoString += `. GPS: ${equipamientos.gps}`;
                }
                if (equipamientos.n_precinto !== null) {
                  equipamientoString += `. Precinto: ${equipamientos.n_precinto}`;
                }
                return equipamientoString;
              })
              .join('; '),
            telefonos: telefonosToString(
              maquinaMovil.telefonos,
              this.countries
            ),
            correosElectronicos: maquinaMovil.correos_electronico
              .map((correo) => correo.direccion)
              .join(', '),
            brindaServicios: maquinaMovil.brinda_servicios_terceros
              ? 'Sí'
              : 'No'
          };
        }),
        viveros: this.viveros.map((vge) => {
          const especies = this.buscarNombreEspecie(
            vge.grupos_especies_id
          ).join('; ');
          return {
            nombre: vge.nombre,
            especies: especies || 'No tiene'
          };
        })
      } as any,
      movimientoTramite: this.movimientoTramiteCurrentEmpresa
    } as EmpresaFilePayload;

    downloadEmpresaDetail(empresaDetail);
  }

  onHideCertificadoNotarial(naturalezaJuridicaId: any): boolean {
    // Ocultar certificado notarial | lastUpdate 15/08/2024
    // 15 (Unipersonal
    const data: { [key: number]: boolean } = {
      [`${15}`]: true
    };

    if (!data[naturalezaJuridicaId]) {
      return false;
    }

    if (!naturalezaJuridicaId) {
      return false;
    }

    return (data as any)[naturalezaJuridicaId];
  }

  nombreEmpresa(entidadProductiva: EntidadesProductiva): string {
    if (entidadProductiva.persona_fisica_id) {
      return this.personaById(
        this.personaFisicaByEntidadProductiva(entidadProductiva).persona_id
      ).nombre_completo;
    }

    if (entidadProductiva.persona_juridica_id) {
      return this.personaJuridicaById(entidadProductiva.persona_juridica_id)
        .denominacion_social;
    }

    return 'La empresa no tiene nombre';
  }

  almotOneEditableRol(roles: Rol[]): boolean {
    let titular = roles.find((r) => r.tipo_rol_id === 1);
    let representanteLegal = roles.find((r) => r.tipo_rol_id === 2);
    let representante = roles.find((r) => r.tipo_rol_id === 5);
    let apoderado = roles.find((r) => r.tipo_rol_id === 3);
    let administrativoResponsable = roles.find((r) => r.tipo_rol_id === 4);

    if (
      titular ||
      representanteLegal ||
      representante ||
      apoderado ||
      administrativoResponsable
    ) {
      return true;
    } else {
      return false;
    }
  }

  buscarLaboratoriosById(ids?: number[]) {
    if (!ids) return [];
    return this.laboratorios.filter((l) => ids.includes(l.id));
  }
}
